import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { ShieldCheck, Lock, CreditCard, Star, XCircle } from 'lucide-react';
export const Hero = () => {
  return <section className="bg-bg-base px-4 pt-4 pb-7 md:pt-16 md:pb-16 overflow-hidden" data-id="element-303" data-mp="mz5vbfm4mugs">
      <div className="max-w-[700px] mx-auto text-center space-y-2.5 md:space-y-6" data-id="element-304" data-mp="rubpf1ponffy">
        <FadeIn data-id="element-305" data-mp="wqsato5hzfpc">
          <div className="space-y-2 md:space-y-4" data-id="element-306" data-mp="wteo84f2kpfh">
            <div className="inline-flex items-center gap-1.5 bg-bg-card text-brandGold font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full border border-brandGold/40" data-id="element-307" data-mp="3va0ptrn0py7b">
              <span className="text-sm md:text-base" data-id="element-308" data-mp="90fz0274syth">🎨</span>
              <span className="text-[8.5px]" data-id="element-309" data-mp="e13x17ts2fx7">
                MEGAPACK COLORIMETRÍA LISTA™
              </span>
            </div>
            <h1 className="font-hero font-bold uppercase text-[25px] md:text-[56px] leading-[1.13] md:leading-[1.08] tracking-[0.5px] text-txt-primary mx-auto max-w-[24ch] md:max-w-[20ch] px-1 pt-1.5 pb-0.5 md:px-2 md:pt-3 md:pb-1" data-id="element-310" data-mp="1kgeaecps7wxv">
              <span className="block" data-id="element-311" data-mp="1cb7q8x7dw9k4">DOMINÁ LOS</span>
              <span className="block text-brandGold" data-id="element-312" data-mp="1ccirap9g337j">PLATINADOS Y BLANCOS.</span>
              <span className="block" data-id="element-313" data-mp="188kuil7le4hn">SIN MIEDO A LOS REFLEJOS AMARILLOS.</span>
            </h1>

            <p className="text-txt-body text-[11.5px] md:text-[16px] leading-[1.4] md:leading-[1.7] font-sans px-3" data-id="element-314" data-mp="13bcdiny6k6hz">Platinados sin manchas • Blancos puros • Fantasía controlada • Técnicas roots • Mechas platinadas • Acceso de por vida
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-315" data-mp="ol50wouuthp7">
          <a href="#pricing" className="block cursor-pointer relative" data-id="element-316" data-mp="omg6mu7v0ziy">
            <div className="absolute inset-0 bg-brandGold/15 blur-[40px] rounded-full" data-id="element-317" data-mp="kkl27gumu60y"></div>
            <div className="absolute inset-y-0 -inset-x-10 bg-brandGold/10 blur-[28px] rounded-full" data-id="element-318" data-mp="flhzi324kbw5"></div>
            <img src="https://cdn.magicpatterns.com/uploads/agacHF4oUprc8XhkQK75E2/mockup_sticker.png" alt="Megapack Colorimetría Lista — Mockup completo del producto" loading="eager" decoding="async" width={1000} height={1000}
          // @ts-ignore — supported by modern browsers
          fetchpriority="high" className="relative block w-full max-w-[250px] md:max-w-[560px] mx-auto h-auto object-contain hover:-translate-y-1 transition-transform duration-300 drop-shadow-2xl" data-id="element-319" data-mp="alltxzds4ceh" />
          </a>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-320" data-mp="jpsjimwlmgbn">
          <div className="max-w-2xl mx-auto space-y-2.5 md:space-y-5" data-id="element-321" data-mp="jpj2vpxg1lim">
            {/* Chips - same on all screens */}
            <div className="flex flex-wrap gap-1.5 md:gap-2 justify-center items-center" data-id="element-322" data-mp="oponwn97k9rq">
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-323" data-mp="9wv62v6grhjw">
                <span className="text-[10px] md:text-xs" data-id="element-324" data-mp="12lsdg394ztxv">📄</span> 100% PDF +
                Videos HD
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-325" data-mp="2s4h49csbmrx2">
                <span className="text-[10px] md:text-xs" data-id="element-326" data-mp="31v21avscjodv">⚡</span> Acceso en 5
                min
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-327" data-mp="2wwiekt5xi8kg">
                <span className="text-[10px] md:text-xs" data-id="element-328" data-mp="247tk3czdp1ho">📚</span> 475+ páginas
                + 14 h de video
              </span>
            </div>

            {/* CTA button + trust */}
            <div className="space-y-2 md:space-y-3" data-id="element-329" data-mp="2e4pvprkkq3qg">
              <CTAButton href="#pricing" fullWidth className="!py-3.5 md:!py-4 !text-[14px] md:!text-base" data-id="element-330" data-mp="2e7c5zyyumxcd">
                🎨 QUIERO EL MEGAPACK AHORA
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 text-[9.5px] md:text-xs text-txt-muted font-sans" data-id="element-331" data-mp="3pjv3h9zkasgx">
                <span className="flex items-center gap-1" data-id="element-332" data-mp="sq8ubpcdy5wv">
                  <ShieldCheck size={11} className="text-success" data-id="element-333" data-mp="sqsc9621cuaw" /> Garantía 7
                  días
                </span>
                <span className="flex items-center gap-1" data-id="element-334" data-mp="xry4l2rsafjw">
                  <Lock size={11} className="text-txt-muted" data-id="element-335" data-mp="12q9hxnhaf86v" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-336" data-mp="17mztpym27hmh">
                  <CreditCard size={11} className="text-brandGold" data-id="element-337" data-mp="1bp4lersy646h" /> Pagas en
                  tu moneda local
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  const stats = [{
    value: '+500',
    label: 'barberos lo recomiendan'
  }, {
    value: '+14 HS',
    label: 'En video'
  }, {
    value: '4',
    label: 'Manuales Técnicos'
  }, {
    value: '4.9/5',
    label: 'calificación',
    star: true
  }];
  return <div className="bg-bg-alt border-y border-line py-6" data-id="element-338" data-mp="3fwft47heq1z0">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-339" data-mp="3awbbge4rj177">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x divide-line" data-id="element-340" data-mp="3avifm87cdw3u">
          {stats.map((stat, i) => <FadeIn key={stat.label} delay={0.1 + i * 0.1} data-id="element-341" data-mp="35zb5e37wxyg3" data-mpi={i}>
              <div className="font-display font-bold text-[30px] md:text-[42px] leading-[1.1] text-brandGold mb-0.5" data-id="element-342" data-mp="30z7079cggq56">
                {stat.value}
              </div>
              <div className="text-sm font-sans text-txt-body flex items-center justify-center gap-1" data-id="element-343" data-mp="3tn2te42tfzx7">
                {stat.label}
                {stat.star && <Star size={12} className="fill-gold text-gold" data-id="element-344" data-mp="3ourqqtgoy00y" />}
              </div>
            </FadeIn>)}
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'JM',
    text: 'No sabía como realizar platinados. Con esto aprendí como hacerlos. Me ayudo mucho, gracias.',
    author: 'Juan M.',
    role: 'Barbero Profesional · Argentina',
    bg: 'bg-brandGold text-[#14100A]'
  }, {
    initials: 'CS',
    text: 'Implemente el servicio de color. Ahora realizo trabajos completos y sin dudas, ahora se exactamente que fórmulas utilizar. Muy recomendable.',
    author: 'Carlos S.',
    role: 'Dueño de Barbería · México',
    bg: 'bg-brandSteel-deep text-white'
  }, {
    initials: 'RF',
    text: 'Descargué todo el curso. Me llego inmediatamente, esta muy bien detallado con tendencias actualezsadas .',
    author: 'Roberto F.',
    role: 'Colorista · Colombia',
    bg: 'bg-brandGold text-[#14100A]'
  }];
  return <Section className="bg-bg-base" data-id="element-345" data-mp="1i094mqyirwgd">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5 md:gap-4" data-id="element-346" data-mp="1i1ac6lgbu0tc">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-347" data-mp="1mysmog9zso3g" data-mpi={i}>
            <div className="bg-bg-card p-3.5 md:p-5 rounded-[14px] md:rounded-[18px] border border-line h-full flex flex-col" data-id="element-348" data-mp="3cd76qna2fmsm">
              <div className="flex items-center gap-2.5 mb-2.5" data-id="element-349" data-mp="3hc1tu1f2fxij">
                <div className={`w-8 h-8 md:w-9 md:h-9 ${t.bg} rounded-full flex items-center justify-center font-sans font-bold text-[11px] md:text-xs shrink-0`} data-id="element-350" data-mp="15of3e1qo3uqf">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-351" data-mp="1fft8qq5avorh">
                  <div className="flex text-gold mb-0.5" data-id="element-352" data-mp="1fgum519sgncd">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-353" data-mp="1am86un0l6an0" data-mpi={j} />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[12px] md:text-[13px] leading-tight" data-id="element-354" data-mp="1ohsq5jk88uuy">
                    {t.author}
                  </p>
                  <p className="text-[10px] md:text-[11px] font-sans text-txt-muted" data-id="element-355" data-mp="1ycub037gzarq">
                    {t.role}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[12.5px] md:text-[13.5px] leading-[1.5] italic" data-id="element-356" data-mp="3zcnuhaz8fx8">
                "{t.text}"
              </p>
              <p className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandGold mt-auto pt-2.5" data-id="element-357" data-mp="3v80cb64ikj90">
                Compró el Megapack
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Problem = () => {
  const painPoints = ['Aplicás fórmulas o técnicas con información que encontraste por videos', 'Llegás al fondo de decoloración pero el pelo queda con manchas amarillas o naranjas', 'Improvisás mezclas esperando que el matizador "haga el milagro" pero el resultado nunca es profesional', 'Sentís miedo de quemar el pelo o fallar en la fórmula y terminar cobrando muy barato por inseguridad', 'Ves trabajos increíbles en Instagram pero no sabés cómo llegar a esos grises premium y blancos limpios', 'Conocés sobre el tema, pero no estás conforme con el resultado final y el ciclo se repite'];
  return <Section className="bg-bg-alt" data-id="element-358" data-mp="flb4ht4gzb0v">
      <div className="max-w-[720px] mx-auto" data-id="element-359" data-mp="fofe560peyyx">
        <FadeIn data-id="element-360" data-mp="jmmxm8mjyedt">
          <h2 className="font-display font-bold uppercase md:text-[36px] text-center mb-8 text-txt-primary text-[22px] leading-[1.25] tracking-[0.5px]" data-id="element-361" data-mp="jm3dcl9fjdwm">
            ¿Te pasa esto cuando llega un <span className="text-brandGold" data-id="element-362" data-mp="2056hta8dahzw">cliente</span>
            <br data-id="element-363" data-mp="1vdezto3a1kld" />
             pidiendo
color?

          </h2>

          <div className="space-y-2 md:space-y-3 mb-10" data-id="element-364" data-mp="1vbke47k6log8">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2.5 bg-bg-card border border-line rounded-[10px] py-2.5 px-3 md:py-3 md:px-4" data-id="element-365" data-mp="1qdisbevdfb12" data-mpi={i}>
                <XCircle className="text-danger shrink-0 mt-0.5" size={16} data-id="element-366" data-mp="1lcuxsj7xoc23" />
                <p className="text-txt-body font-sans text-[13px] md:text-[15px] leading-[1.5]" data-id="element-367" data-mp="1getcdrn1c0ng">
                  {point}
                </p>
              </div>)}
          </div>

          {/* Gold divider */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mb-10 md:mb-12 bg-brandGold" style={{
          boxShadow: '0 0 12px rgba(212,162,76,0.7), 0 0 24px rgba(212,162,76,0.4)'
        }} data-id="element-368" data-mp="17hj3gcxownlp"></div>

          <h3 className="font-display font-bold uppercase md:text-[40px] text-center text-txt-primary mb-8 relative text-[24px] leading-[1.2] tracking-[0.5px]" data-id="element-369" data-mp="31rmqkx8zrlbx">
            ¿Sigues improvisando{' '}
            <span className="text-brandGold inline-block" style={{
            textShadow: '0 0 20px rgba(212,162,76,0.5), 0 0 40px rgba(212,162,76,0.3)'
          }} data-id="element-370" data-mp="dewfi0cw6ugw">
             con tus clientes?
            </span>
          </h3>

          <div className="space-y-4 text-txt-body font-sans text-[15px] md:text-base leading-[1.7] mb-10" data-id="element-371" data-mp="3usa2c2jy0sff">
            <p style={{
            paddingLeft: "10px"
          }} data-id="element-372" data-mp="3qshpverfi24s">
              Elegiste este camino porque amás esta profesión, trabajar en la imagen de las personas y ganar dinero en serio.
            </p>
            <p style={{
            paddingLeft: "9px"
          }} data-id="element-373" data-mp="3lyvfps94xg6">
              Pero nadie te dijo que ibas a perder tiempo y dinero, improvisando sobre la marcha, intentando descubir EL SECRETO EXACTO que utilizan los barbéros: dónde TODO esté organizado, donde NO FALLES y
              puedas COBRAR lo que realmente vale tu trabajo.
            </p>
          </div>

          {/* Highlighted closing question */}
          <div className="relative bg-bg-card border-2 border-brandGold rounded-[16px] py-5 px-5 md:py-6 md:px-8 shadow-[0_0_40px_rgba(212,162,76,0.2)]" data-id="element-374" data-mp="1rdg4z68seoab">
            <p className="font-display font-bold text-[18px] md:text-[26px] leading-[1.3] text-center text-txt-primary uppercase tracking-[0.5px]" data-id="element-375" data-mp="1ijbggth4loxy">
              ¿Y SI HOY TUVIERAS TODO LISTO PARA{' '}
              <span className="text-brandGold" data-id="element-376" data-mp="2abamk8nze84b">DOMINAR LA TÉCNICA?</span>
            </p>
          </div>

          {/* Gold divider — transition to product */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mt-10 md:mt-14 bg-brandGold" style={{
          boxShadow: '0 0 12px rgba(212,162,76,0.7), 0 0 24px rgba(212,162,76,0.4)'
        }} data-id="element-377" data-mp="1wdm0ixi6guxo"></div>
        </FadeIn>
      </div>
    </Section>;
};